import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../../../colors-v2';
import { BaseCard, BaseCardProps } from '../BaseCard/BaseCard';
import { MetaInProgressBar, MetaProps } from '../components/MetaInProgressBar';
import { Title } from '../components/Title';

const ActionsSection = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 1fr;
  column-gap: 8px;
  align-items: center;
`;

const MainInfo = styled.div`
  display: grid;
  row-gap: 4px;

  .link-title {
    color: ${colorsV2.black100};
    &:hover {
      text-decoration: underline solid ${colorsV2.black100};
    }
  }

  .title {
    overflow: hidden;
  }
`;

const Layout = styled.section`
  display: grid;
  height: 100%;
  grid-template-rows: 1fr auto;
  align-items: flex-start;
  row-gap: 16px;
  padding-top: 16px;

  .directional-horizontal & {
    padding-top: 0;
    padding-left: 16px;
    row-gap: 8px;
  }
`;

const StyledBaseCard = styled(BaseCard)`
  &.ant-card {
    border-radius: 0;
  }
`;

const SubTextsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

interface ActionModel {
  id?: string;
  render: () => React.ReactNode;
  visible?: boolean;
}

export interface BasicCardProps extends BaseCardProps {
  title: React.ReactNode;
  url?: string;
  metadata?: MetaProps['metadata'];
  actions?: ActionModel[];
}

export const BasicCard = (props: BasicCardProps) => {
  const { title, url, metadata, media, actions, ...rest } = props;

  return (
    <StyledBaseCard
      url={url}
      media={{
        rounded: true,
        ...media,
      }}
      {...rest}
    >
      <Layout>
        <MainInfo>
          <Title typoVariantTablet="semi-bold/20" url={url} text={title} />
          <SubTextsWrapper>{metadata && <MetaInProgressBar metadata={metadata} />}</SubTextsWrapper>
        </MainInfo>
        <ActionsSection>
          {actions?.map((action) => {
            const { visible: actionVisible = true, render: actionRender } = action;
            if (actionVisible)
              return <React.Fragment key={action.id}>{actionRender()}</React.Fragment>;
            return null;
          })}
        </ActionsSection>
      </Layout>
    </StyledBaseCard>
  );
};
